module.exports = __webpack_public_path__ + "img/logo_u1992-7.6255b59e.svg";